  // ロイヤルカナン ===== 開始 =====
  let timeoutID;
  // ロイヤルカナン ===== 終了 =====

var decodeData = window.location.search.substring(1);
  if(decodeData!=''){
     let query = window.decodeURIComponent(window.location.search.substring(1));
    var productId =getQueryVariable(query,"productId");
    var selectedVariantId = getQueryVariable(query,"selectedVariantId");
    var selectCount=getQueryVariable(query,"selectCount");
    var productTags=getQueryVariable(query,"productTags");
    var productUrl=getQueryVariable(query,"productUrl");
    // ロイヤルカナン ===== 開始 =====
    var selectedJanCode=getQueryVariable(query,"selectedJanCode");
    // ロイヤルカナン ===== 終了 =====
  }

  $(document).ready(function(){
    //「店舗受取可能エリア」を受取可能店舗リスト
     // 受取可能エリアある
    var data = {
      productId:productId
    }
    fetch('https://'+ storeUrl +'/apps/proxy/mypage/storePickUp/onload', {
      method: 'POST',
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.status >= 500 && response.status <= 599) {
        throw Error('しばらくしてから再度実行してください。');
      }
      return response;
    })
    .then(response => response.json())
    .then(data => {
      
      if(!isEmpty(data)){
        setFavoriteStore(data);
      } 
    })
    .catch(error => {
      // #72661  20230222 張娟娟 start
      $("#errorMessage").removeAttr("hidden");
      $('#errorMessage').addClass('errorMessageArea');
      $('#errorMessage').html("システムメンテナンスを行っております。<br>しばらくたってから再度お試し下さい。");
      // #72661  20230222 張娟娟 end
    });
  });

  function keydown(e){
    if(e.keyCode === 13){
      var searchValue=document.activeElement.name;
      if(searchValue=="store-search-word"){
        $('#searchStore').focus();
      }
    }
  }
  window.onkeydown = keydown;

  // お気に入り店舗を設定する
  function setFavoriteStore(data){

    // table要素を取得
    var ulElem = document.getElementById('favoriteStoreBody');
    $('#favoriteStoreBody').find("li").remove();
   
    $.each(data, function (index, value) {
    
      // 追加する要素を作成します
      // ----------------------------
      var liElem = document.createElement("li");

      // radioButton要素にテキストを追加
      const radioButton = document.createElement("input");
      radioButton.setAttribute("type", "radio");
      radioButton.setAttribute("id", "pick-up-store-"+value.storeCode);
      radioButton.setAttribute("name", "pick-up-store-name");
      // 店舗名コートと店舗名
      var store="storeCode=".concat(value.storeCode).concat("&storeName=").concat(value.storeName);

      // label要素にテキストを追加
      const label = document.createElement("label");
      label.setAttribute("for", "pick-up-store-"+value.storeCode);
      label.innerText=value.storeName+"　（店舗受取不可）";

      // 店舗受取可能
      if(value.storePickUpFlag==1){
        // 物流センターID
           //store=store.concat("&distriCenterID=").concat(value.distributionCenter);
           //物流センター名
           store=store.concat("&distriCenterNm=").concat(value.distributionCenterName);
           //郵便番号
           store=store.concat("&postalCode=").concat(value.postalCode);
           //住所
           store=store.concat("&address=").concat(value.address);
           //電話番号
           store=store.concat("&phone=").concat(value.phoneNumber);
           
           label.innerText=value.storeName;
      }
     
       radioButton.setAttribute("value", store);
       if(value.storePickUpFlag==0){
         radioButton.setAttribute("disabled", "true");
       }     
   
      liElem.appendChild(radioButton);
      liElem.appendChild(label);
      ulElem.appendChild(liElem);
    });
    
  }

  // 検索ボタンを押下
  $('#searchStore').on('click', function() {
    // #72661  20230222 張娟娟 start
    $('#errorMessage').html('');
    $('#errorMessage').removeClass();
    // #72661  20230222 張娟娟 end
    
    var searchValue = $('input[name="store-search-word"]').val();
    var data = {
      productId:productId,
      searchValue: searchValue
    }
    fetch('https://'+ storeUrl +'/apps/proxy/mypage/storePickUp/search', {
      method: 'POST',
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.status >= 500 && response.status <= 599) {
        throw Error('しばらくしてから再度実行してください。');
      }
      return response;
    })
    .then(response => response.json())
    .then(data => {
      if(isEmpty(data)){
        $('#searchStoreBody').html('');
        $('#PaginationId').html('');
      }else{
     　　setStore(data);
      } 
    })
    .catch(error => {
      // #72661  20230222 張娟娟 start
      $("#errorMessage").removeAttr("hidden");
      $('#errorMessage').addClass('errorMessageArea');
      $('#errorMessage').html("システムメンテナンスを行っております。<br>しばらくたってから再度お試し下さい。");
      // #72661  20230222 張娟娟 end
    });
  });

  // 検索のデータを設定する
  function setStore(data){
    
    // table要素を取得
    var ulElem = document.getElementById('searchStoreBody');
    let container = $('#PaginationId');
    container.pagination({
      dataSource: data,
      prevText: `<svg class="pagiNation-Item-Link-Icon" style="width: 12px;" viewBox="0 0 100 100">
        <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path>
      </svg>`,
      nextText: `<svg class="pagiNation-Item-Link-Icon" style="width: 12px;" viewBox="0 0 100 100">
        <path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)"></path>
      </svg>`,
      pageSize: 5,
      callback: function (data, pagination) {
        $('#searchStoreBody').find("li").remove();
        $.each(data, function (index, value) {
          // 追加する要素を作成します
          // ----------------------------
          var liElem = document.createElement("li");
          // radioButton要素にテキストを追加
          const radioButton = document.createElement("input");
          radioButton.setAttribute("type", "radio");
          radioButton.setAttribute("id", "pick-up-store-"+value.storeCode);
          radioButton.setAttribute("name", "pick-up-store-name");
          var store="storeCode=".concat(value.storeCode).concat("&storeName=").concat(value.storeName);
           // 物流センターID
           //store=store.concat("&distriCenterID=").concat(value.distributionCenter);
           //物流センター名
           store=store.concat("&distriCenterNm=").concat(value.distributionCenterName);
           //郵便番号
           store=store.concat("&postalCode=").concat(value.postalCode);
           //住所
           store=store.concat("&address=").concat(value.address);
           //電話番号
           store=store.concat("&phone=").concat(value.phoneNumber);
          
          radioButton.setAttribute("value", store);
          if(value.storePickUpFlag=="0"){
            radioButton.setAttribute("disabled", "true");
          }
 
          // label要素にテキストを追加
          const label = document.createElement("label");
          label.setAttribute("for", "pick-up-store-"+value.storeCode);
          if(value.storePickUpFlag=="1"){
             label.innerText=value.storeName;
          }else{
            label.innerText=value.storeName+"（店舗受取不可）";
          }
          liElem.appendChild(radioButton);
          liElem.appendChild(label);
          ulElem.appendChild(liElem);

         
        });
      }
    })
  }
 
  // OKボタンを押下
  $('#toCartPage').on('click', function() {
    // #72661  20230222 張娟娟 start
    $('#errorMessage').html('');
    $('#errorMessage').removeClass();
    // #72661  20230222 張娟娟 end
    
    // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 start
    $("#toCartPage").prop("disabled", true);
    // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 end
    
    var storeInfo = $('input:radio[name="pick-up-store-name"]:checked').val();
    if(isEmpty(storeInfo)){
      // #72661  20230222 張娟娟 start
      $("#errorMessage").removeAttr("hidden");
      $('#errorMessage').addClass('errorMessageArea');
      $('#errorMessage').html("受取店舗を選択してください。");
      // #72661  20230222 張娟娟 end
      
      // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 start
      $("#toCartPage").prop("disabled", false);
      // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 end
      return;
    }

    var data = {
      storeCode:getQueryVariable(storeInfo,"storeCode")
    }
    fetch('https://'+ storeUrl +'/apps/proxy/mypage/storePickUp/storePickUpBeforeCheck', {
      method: 'POST',
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.status >= 500 && response.status <= 599) {
        // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 start
        $("#toCartPage").prop("disabled", false);
        // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 end
        throw Error('しばらくしてから再度実行してください。');
      }
      return response;
    })
    .then(response => response.json())
    .then(data => {
      //エラーがある
      if(!isEmpty(data.errorMessage)){
        // #72661  20230222 張娟娟 start
        $("#errorMessage").removeAttr("hidden");
        $('#errorMessage').addClass('errorMessageArea');
        $('#errorMessage').html(data.errorMessage);
        // #72661  20230222 張娟娟 end
      }else{
        let query = window.decodeURIComponent(window.location.search.substring(1));
        var variantId = getQueryVariable(query,"variant");
        if(isEmpty(variantId)){
          variantId = selectedVariantId;
        }
        
        //問診に遷移する,ロイヤルカナン対応
        if("1"==productTags || "2"==productTags){
          setStorePickUpInfo("仮店舗受取情報");
        }else{
          // cartに追加する。
          let formData = {
            'items': [{
              'id': variantId,
              'quantity':selectCount
            }]
          };

          // 予約対応 maruo start
          var pre_flg = getQueryVariable(query,"pre_flg");
          if(pre_flg){
            formData = {
              'items': [{
                'id': variantId,
                'quantity':selectCount,
                'properties': {
                  "_pre_order_flg": "true",
                  "注文": "予約商品",
                },
              }]
            };
          }
          // 予約対応 maruo end

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
          .then(response => response.json())
          .then(data => {
            setStorePickUpInfo("店舗受取情報");
             
          })
          .catch((error) => {
            console.error('Error:', error);
            // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 start
            $("#toCartPage").prop("disabled", false);
            // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 end
          });
        }   
      } 
     
    })
    .catch(error => {
      // #72661  20230222 張娟娟 start
      $("#errorMessage").removeAttr("hidden");
      $('#errorMessage').addClass('errorMessageArea');
      $('#errorMessage').html("システムメンテナンスを行っております。<br>しばらくたってから再度お試し下さい。");
      // #72661  20230222 張娟娟 end
      // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 start
      $("#toCartPage").prop("disabled", false);
      // #72258 ボタンの非活性の制御処理 追加 20220111 張娟娟 end
    });
  });

　// 店舗受取情報を設定する
  function setStorePickUpInfo(cartAttributeName) {
    // 店舗受取情報
    var decodeData = $("input[type=radio][name=pick-up-store-name]").filter(":checked")[0].value;
    if(decodeData!=''){

      //物流センター名
      var distriCenterNm = "【".concat(getQueryVariable(decodeData,"distriCenterNm")).concat("】");
      // 店舗名
      var storeName = getQueryVariable(decodeData,"storeName").concat(" ");
      // 店舗ID
      var storeId = getQueryVariable(decodeData,"storeCode").concat(" Ω\n"); 
      // 郵便番号
      var postcode = getQueryVariable(decodeData,"postalCode");
      postcode = postcode.substr(0,3) + "-" + postcode.substr(3);
      var postalCode = "〒".concat(postcode).concat(" Ω\n");
      // 住所
      var address = getQueryVariable(decodeData,"address").concat(" Ω\n");
      // 電話番号
      var phone = "TEL : ".concat(getQueryVariable(decodeData,"phone"));

      var mypickupInfo=distriCenterNm.concat(storeName).concat(storeId).concat(postalCode).concat(address).concat(phone);
      $('#mypickupinfo').val(mypickupInfo);
      // const attributes = {
      //   attributes: {
      //     '店舗受取情報': mypickupInfo
      //   }
      // };

      //attribute の名前を宣言する
     // const cartAttributeName = "店舗受取情報";

      // ロイヤルカナン ===== 開始 =====
      let query = window.decodeURIComponent(window.location.search.substring(1));
      let variantId = getQueryVariable(query,"variant");
              if(isEmpty(variantId)){
          variantId = selectedVariantId;
        }
      console.log("variantId:"+variantId);
      let JanCode = getQueryVariable(query,"jancode");
        if(isEmpty(JanCode)){
          JanCode = selectedJanCode;
        }
      console.log("JanCode:"+JanCode);
      let selectCount = getQueryVariable(query,"selectCount");
        if(isEmpty(selectCount)){
          selectCount = selectedselectCount;
        }
      console.log("selectCount:"+selectCount);
      // ロイヤルカナン =====終了 =====

      if(productTags != "2"){
      var object = {};
      var attributes = {};
      //購入前チェックフォームデータを object に保存する
      object[cartAttributeName] = mypickupInfo;
      //object を attribute　に保存する
      attributes['attributes'] = object;
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(attributes),
      })
      .then(response => response.json())
      .then(data => {
        //問診に遷移する
        if("1"==productTags){
          var url = "/pages/questionnaire?productId="+productId+"&variant="+selectedVariantId+"&quantity="+selectCount+"&productTags=1";
          //購入前チェックペイジーに遷移する
          $(window).attr('location',url);  
        }else{
          　$(window).attr('location',"/cart");
        }
      
      
        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      // ロイヤルカナン対応
    } else if (productTags == "2") {
      // productTagsが2の場合、mypickupInfoの情報をセッションストレージに保存する処理
      sessionStorage.removeItem('rcmypickupInfo');
      rcmypickupInfo = {
        "attributes":{
          "店舗受取情報" : mypickupInfo
        }
      };
      sessionStorage.setItem('rcmypickupInfo', JSON.stringify(rcmypickupInfo));
      let registerButton = document.querySelector('#toCartPage');
      registerButton.classList.add('js-modal-open');
      let rcRequestData = {
        "s":variantId ,
        "gl": [{ "g": JanCode , "q": selectCount }]
      }
      $('#toCartPage').on('click', modalOpen(rcRequestData));
      }
    }
  }

  function getQueryVariable(query,variable){
   
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] == variable){return pair[1];}
    }
    return(false);
  }

  function isEmpty(obj){
    if(typeof obj == "undefined" || obj == null || obj == ""){
      return true;
    }else{
      return false;
    }
  }
  // 戻るボタンを押下
  function toProductPage(){
    $(window).attr('location',productUrl);
  }

  // ロイヤルカナン ===== 開始 =====
function modalOpen(requestData) {   
  const modal = document.querySelector('.js-modal');  
  modal.classList.add('is-active'); 
  document.body.classList.add('is-active');
　$('#productName').addClass('productNameArea');
  $('#productName').html("商品名："+sessionStorage.getItem('rcProductTitle'));
　$('#productImg').addClass('productImgArea');
　$('#productImg').attr("src", sessionStorage.getItem('rcProductImgeSrc')+'| img_url: \'200x200\'');
  

  fetch('https://'+ storeUrl +'/apps/proxy/mypage/rcEncryptRequest/get', {
    method: 'POST',
    body: JSON.stringify(requestData)
  })
  .then(response => {  
    if (response.status != 200) {
      $("#errorMessage").removeAttr("hidden");
      $('#errorMessage').addClass('errorMessageArea');
      $('#errorMessage').html("システムメンテナンスを行っております。<br>しばらくたってから再度お試し下さい。");
      $("#toCartPage").prop("disabled", false);
      modalClose();
      return;
    }
    return response.json();
  })
  .then(json => {
    const reqEncryptedJson = JSON.parse(JSON.stringify(json).trim());
    timeoutID = setTimeout(() => {
      // 認証サイトに遷移
      window.location.href = 'https://ks-pet-health-link.jp/?cert_req='+reqEncryptedJson.cert_req; 
    }, 5000); 
  })  
  .catch(error => {
      $("#errorMessage").removeAttr("hidden");
      $('#errorMessage').addClass('errorMessageArea');
      $('#errorMessage').html("システムメンテナンスを行っております。<br>しばらくたってから再度お試し下さい。");
      $("#toCartPage").prop("disabled", false);
      modalClose();
      return;
  });
}
const close = document.querySelector('.js-modal-close');  
close.addEventListener('click', modalClose);  

function modalClose() {  
  const modal = document.querySelector('.js-modal');  
  modal.classList.remove('is-active');
  document.body.classList.remove('is-active');
  $("#toCartPage").prop("disabled", false);
  clearTimeout(timeoutID);
}  
  // ロイヤルカナン ===== 終了 =====